import React from "react";
import resume from "./assets/Resume.pdf";
import "./index.css";

const App = () => {
  return (
    <main className="under-construction">
      <section className="under-construction__card">
        <p className="under-construction__eyebrow">Website Update In Progress</p>
        <h1>Under Construction</h1>
        <p className="under-construction__description">
          I am rebuilding this website and adding fresh work. In the meantime,
          you can download my CV below.
        </p>
        <div className="under-construction__cta-row">
          <a href={resume} download="Anastasia_S_Resume.pdf" className="btn btn-primary">
            Download CV
          </a>
          <a
            href="https://www.linkedin.com/in/anastasia-starostina-900bb2130"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            LinkedIn
          </a>
          <a
            href="https://github.com/nsstarr"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            GitHub
          </a>
        </div>
      </section>
    </main>
  );
};

export default App;
